import React from "react";

// Custom Styles
import "../scss/pages/contact.styles.scss";

// Assets
import PhoneIconRed from "../assets/img/phone-icon--red.svg";
import ClockIconRed from "../assets/img/clock-icon--red.svg";
import EmailIconRed from "../assets/img/email-icon--red.svg";
import LocationIconRed from "../assets/img/location-icon--red.svg";
import ContactHeader from "../assets/img/contact-header.jpg";

function Contact() {
  return (
    <>
      <section
        className="contact__jumbotron"
        style={{
          backgroundImage: `url( ${ContactHeader})`,
        }}
      >
        <h3>Contacto</h3>
      </section>
      <section className="contact__info-links">
        <div className="contact__info-links__item">
          <img src={PhoneIconRed} alt="" srcset="" />
          <h3>Teléfono admisiones</h3>
          <a href="tel:+">(449)-975-2100</a>
        </div>
        <div className="contact__info-links__item">
          <img src={EmailIconRed} alt="" srcset="" />
          <h3>Correo electrónico</h3>
          <a href="mailto:contacto@ensfa.edu.mx">contacto@ensfa.edu.mx</a>
        </div>
        <div className="contact__info-links__item">
          <img src={ClockIconRed} alt="" srcset="" />
          <h3>Horarios</h3>
          <p>Lunes - Viernes: 8am - 3pm​ </p>
        </div>
        <div className="contact__info-links__item">
          <img src={LocationIconRed} alt="" srcset="" />
          <h3>Ubicación</h3>
          <a href="tel:+">Av. Nazario Ortiz Garza S/N, Aguascalientes, Ags.</a>
        </div>
      </section>
    </>
  );
}

export default Contact;
